export default __webpack_public_path__ + "static/A06-f740553fcb3b64d72310cefd70b52a6c.jpg";